import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { totalRepliesReceivedConfig } from '../totalRepliesReceived';

export const mediaViewerRepliesReceivedConfig = {
    ...totalRepliesReceivedConfig,
    tooltip: null,
    orientation: ORIENTATION_VERTICAL,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
